import { Injectable, NgZone } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ZoneInterceptor implements HttpInterceptor {
  constructor(private zone: NgZone) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable(observer => {
      const subscription = next.handle(req).subscribe({
        next: (event) => this.zone.run(() => observer.next(event)),
        error: (error) => this.zone.run(() => observer.error(error)),
        complete: () => this.zone.run(() => observer.complete()),
      });
      return () => subscription.unsubscribe();
    });
  }
}
